<div *ngFor="let accordion of vm; let index = index; trackBy: trackByFn" class="accordion-row d-flex flex-column">
  <div
    class="accordion-title d-flex justify-content-between align-item-center"
    (click)="onAccordionTitleAreaClicked(accordion)"
    data-testid="MarketingLandingPage.faqAccordionTitles"
  >
    {{ accordion.question }}
    <svg-icon [key]="openedAccordionListItems.includes(accordion) ? 'cancel' : 'plus'" class="dropdown-icon" fontSize="24px"></svg-icon>
  </div>
  <div class="accordion-description-wrapper" [@expandAnimation]="openedAccordionListItems.includes(accordion) ? 'open' : 'close'">
    <p class="accordion-description mb-4" [innerHTML]="accordion.answer"></p>
  </div>
</div>
